import { render, staticRenderFns } from "./BatchManagerComp.vue?vue&type=template&id=36bf9a08&scoped=true"
import script from "./BatchManagerComp.vue?vue&type=script&lang=js"
export * from "./BatchManagerComp.vue?vue&type=script&lang=js"
import style0 from "./BatchManagerComp.vue?vue&type=style&index=0&id=36bf9a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf9a08",
  null
  
)

export default component.exports